// eslint-disable-next-line no-restricted-imports -- TODO move to @mallardbay/lib-react-components
import type { FormControlProps } from "@chakra-ui/react"
import { CalendarDatePicker } from "@mallardbay/lib-react-components"
import React from "react"
import { useController, useFormContext } from "react-hook-form"

import HookFormControl from "~components/shared/hook-form/core/hook-form-control"

interface Props extends FormControlProps {
    readonly name: string
    readonly label: string
    readonly isRequired?: boolean
    readonly subLabel?: string
    readonly minDate?: number
    readonly maxDate?: number
    readonly placeholder?: string
}

export default function DateControl({
    name,
    label,
    isRequired,
    // subLabel,
    minDate,
    maxDate,
    placeholder,
    ...formControlProps
}: Props) {
    const { control } = useFormContext()

    const {
        field: { name: fieldName, value, onChange },
    } = useController({ control, name })

    return (
        <HookFormControl
            {...formControlProps}
            label={label}
            name={fieldName}
            // subLabel={subLabel}
            isRequired={isRequired}
        >
            <CalendarDatePicker
                selectedDate={value}
                onChange={(newValue) => {
                    if (!newValue) return

                    onChange(newValue)
                }}
                isMulti={false}
                isInline={false}
                isSingleMonth
                placeholder={placeholder}
                minDate={minDate ? new Date(minDate) : undefined}
                maxDate={maxDate ? new Date(maxDate) : undefined}
            />
        </HookFormControl>
    )
}
